
export const timeline = [
    {
        className: "left-container",
        company: "J&Z Couture",
        title: "Software Developer (Full-Time)",
        date: "Aug 2025 - Present",
        description: `Developing a LiDAR-based body measurement system leveraging computer vision and algorithmic modeling to capture precise customer body metrics and automatically generate suit measurements based on customers' needs, eliminating manual measuring and streamlining the tailoring input process.

Built a role-based operations dashboard using React and Firebase to automate Shopify order ingestion and streamline alteration workflows, reducing manual coordination and tailoring errors while doubling turnaround efficiency.

Replaced manual customer call workflows with automated SMS notifications via Twilio, triggering "Ready for Pickup" alerts and status updates, cutting staff workload, improving communication reliability, and implementing reporting to ensure accurate tailor payout tracking for completed work.`,
        skills: "React.js · LiDAR · Computer Vision · Firebase · Cloud Functions · Firestore · Shopify · Twilio · SMS · HMAC · Webhooks · JavaScript",
        arrow: "right",
    },
    {
        className: "right-container",
        company: "Omniado",
        title: "Software Developer ",
        date: "Sep 2023 - Aug 2026",
        description: "Develop tailored applications aligned with client needs, utilizing React.js, PHP, Python, and WordPress. Enhance office productivity by creating and integrating systems such as CRM, CMS, ticketing platforms, and automation bots.",
        skills: "React.js · PHP · Python · WordPress · CRM · CMS · Automation · JavaScript",
        arrow: "right",
    },
    {
        className: "left-container",
        company: "Omniado",
        title: "Software Developer Intern (Full-Time)",
        date: "Jun 2023 - Sep 2023",
        description: "Developed a web-based application for Omniado's client in the credit card processing sector, using PHP, JavaScript, HTML, and CSS. Integrated WordPress CMS, CPanel server management, and PHPMyAdmin. Delivered in five weeks, streamlining the client's onboarding process and reducing human error. Developed a corporate website using React Library to increase brand awareness.",
        skills: "PHP · JavaScript · HTML5 · CSS3 · WordPress · CPanel · PHPMyAdmin · React.js",
        arrow: "right",
    },
    {
        className: "right-container",
        company: "Post Tour Processing",
        title: "Software Engineer (Part-Time)",
        date: "Apr 2024 - Jun 2025",
        description: "Contributed to the development of a currently pending novel patent, and AI-powered software using Python for TTMPT, focusing on data analysis, unit testing, documentation, and research to support first responders and doctors. Developed and deployed a software solution based on USPTO Patent No. 10839067.",
        skills: "Python · AI Development · Data Analysis · Unit Testing · Patent Development · Research",
        arrow: "left",
    },
    {
        className: "left-container",
        company: "AMC Photo Inc",
        title: "Software Developer (Contract)",
        date: "Jul 2024 - Sep 2024",
        description: "Developed and trained an AI model using Python, TensorFlow, and Keras, utilizing CNNs for image processing. The model, trained on a large, structured dataset, analyzes and selects optimal images based on predefined criteria, improving office workflow efficiency and reducing human error, leading to a 25% decrease in product delivery time.",
        skills: "Python · TensorFlow · Keras · CNN · Image Processing · AI/ML · Data Analysis",
        arrow: "left",
    },
    {
        className: "right-container",
        company: "MTJ",
        title: "Retail Software Developer (Part-Time)",
        date: "Jan 2022 - Jan 2024",
        description: "Created a custom invoice system with React library and Firestore database, transitioning the store from handwritten receipts to searchable digital receipts, with inventory integration. Established data infrastructure and increased customer turnover by 10%. Developed and managed a jewelry website and inventory system, streamlining in-store and online sales.",
        skills: "React.js · Firestore · Inventory Management · E-commerce · Digital Transformation · Sales",
        arrow: "left",
    },
]